import Header from '../../components/Header/Header'
import Footer from '../../components/Footer'
import MainContent from '../../components/Home/MainContent/MainContent'
import Client from '../../components/Home/Client/Client'
import WhatWeDo from "../../components/Home/WhatWeDo";
import WhoWeAre from "../../components/Home/WhoWeAre";
import WeAreGoodIn from '../../components/Home/WeAreGoodIn'
import ThingsWeHaveMade from '../../components/Home/ThingsWeHaveMade'
import LatestNews from '../../components/Home/LatestNews'
import WeAreHere from '../../components/Home/WeAreHere'

const styles = {
  HomeWrapper: `flex items-center flex-col sm:justify-between sm:min-h-screen`,
  MainWrapper: `flex w-full justify-center items-center flex-col`,
  mainContainer: "flex px-2 sm:px-14 md:px-24 w-full my-20",
}

const Home = () => {
  return (
    <>
      <section className={styles.HomeWrapper}>
          <header className="w-full">
              <Header />
          </header>

          <main className={styles.MainWrapper}>
              <MainContent />
          </main>

          <section>
                <Client />
          </section>
      </section>
      
      <section className={styles.mainContainer}>
        <WhatWeDo />
      </section>

      <section className={styles.mainContainer}>
        <WhoWeAre />
      </section>

      <section className={styles.mainContainer}>
        <WeAreGoodIn />
      </section>

      <section className={styles.mainContainer.concat(" max-h-screen")}>
        <ThingsWeHaveMade />
      </section>

      <section className={styles.mainContainer.concat(" mt-[28em]")}>
        <LatestNews />
      </section>

      <section className={styles.mainContainer}>
        <WeAreHere />
      </section>

      <footer className="mt-36">
        <Footer />
      </footer>

    </>
  )
}

export default Home